import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import OptInsAndButtonGroup from './OptInsAndButtonGroup';

import { getCachedFullName } from '../../utils/formCaching/helpers';
import { copyFor, capitalization } from '../../copy/copy';
import validate from './validations';

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em;
    transition: opacity 0.6s;

    &.focused {
        opacity: 0;

        &.row-wrapper-2 {
            opacity: 1;

            textarea {
                height: 190px;
            }
        }
    }
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
`;

class PetitionForm extends React.Component {
    constructor() {
        super();
        this.state = {
            valid: false
        };
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }
    render() {
        return (
            <DetailsFormContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                <Row className="row-wrapper-1">
                    <FullRow>
                        <Field
                            name="fullName"
                            component={InputGroup}
                            type="text"
                            label={copyFor(
                                'formFields',
                                'fullName',
                                'petition',
                                capitalization.eachWord
                            )}
                            placeholder={copyFor('placeholders', 'fullName', 'petition')}
                            paddingAdjustment={-3}
                            onFocus={this.props.onInitiated}
                        />
                    </FullRow>
                    <FullRow>
                        <Field
                            name="email"
                            component={InputGroup}
                            type="email"
                            label={copyFor(
                                'formFields',
                                'emailAddress',
                                'petition',
                                capitalization.eachWord
                            )}
                            placeholder={copyFor(
                                'placeholders',
                                'emailAddress',
                                'petition'
                            )}
                            paddingAdjustment={-3}
                            onFocus={this.props.onInitiated}
                        />
                    </FullRow>
                    <FullRow>
                        {this.props.userInfoType === 'address' && (
                            <ReactGoogleAutocomplete
                                formName={['petitionDetailsForm', 'google_autocomplete']}
                                fields={['address_components', 'formatted_address']}
                                types={['address']}
                                typeToReturn={'object'}
                                setValidState={this.setValidState.bind(this)}
                                paddingAdjustment={-3}
                                onFocus={this.props.onInitiated}
                            />
                        )}
                        {this.props.userInfoType !== 'address' && (
                            <Field
                                name={this.props.userInfoType}
                                component={InputGroup}
                                type={this.props.userInfoType}
                                label={copyFor(
                                    'formFields',
                                    this.props.userInfoType,
                                    'petition',
                                    capitalization.eachWord
                                )}
                                placeholder={copyFor(
                                    'placeholders',
                                    this.props.userInfoType,
                                    'petition'
                                )}
                                paddingAdjustment={-3}
                                onFocus={this.props.onInitiated}
                            />
                        )}
                    </FullRow>
                </Row>
                <OptInsAndButtonGroup
                    buttonText={this.props.buttonText}
                    getUpdatesText={this.props.getUpdatesText}
                    invalid={
                        this.props.invalid ||
                        (this.props.userInfoType === 'address' && !this.state.valid)
                    }
                    isEU={!!this.props.endUserLocation.isEU}
                    isSubmitting={this.props.isSubmitting}
                    partnerOptIn={this.props.showPartnerOptIn}
                    partnerOptInText={this.props.partnerOptInText}
                    subscriptionOptInText={this.props.subscriptionOptInText}
                />
            </DetailsFormContainer>
        );
    }
}

PetitionForm.propTypes = {
    buttonText: PropTypes.string.isRequired,
    endUserLocation: PropTypes.object.isRequired,
    getUpdatesText: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onInitiated: PropTypes.func.isRequired,
    partnerOptInText: PropTypes.string,
    showPartnerOptIn: PropTypes.bool.isRequired,
    subscriptionOptInText: PropTypes.string,
    userInfoType: PropTypes.string.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: !(state.widget.endUserLocation || {}).isEU,
            partnerOptIn: !(state.widget.endUserLocation || {}).isEU,
            fullName: getCachedFullName(state),
            email: state.cachedFormData.email || '',
            phone: state.cachedFormData.phone || '',
            postalCode: state.cachedFormData.postalCode || ''
        },
        localRepFullName:
            state.localRep.localRepData.representative !== undefined
                ? state.localRep.localRepData.representative[0].fullName
                : '',
        endUserLocation: state.widget.endUserLocation || {},
        buttonText:
            state.widget.activeAction.customButtonText ||
            copyFor('buttons', 'submit', 'petition', capitalization.eachWord),
        getUpdatesText: state.widget.activeAction.subscriptionOptInText,
        partnerOptInText:
            state.widget.activeAction.partnerOptInText ||
            (state.widget.activeAction.partner || {}).name,
        showPartnerOptIn: state.widget.activeAction.hasPartnerOptIn,
        subscriptionOptInText: state.widget.activeAction.subscriptionOptInText,
        userInfoType: state.widget.activeAction.requiredUserInfo || 'address'
    })),
    reduxForm({
        form: 'petitionDetailsForm',
        validate,
        destroyOnUnmount: false
    })
)(PetitionForm);
